export enum SlotState {
    Idle = "idle", Busy = "busy", Playing = "playing",
}